import { createRouter, createWebHistory } from "vue-router";

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () => import("../views/page.vue"),
  //   meta: { template: "admin" },
  // },
  {
    path: "/maia",
    name: "Maia",
    component: () => import("../views/maia.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/my-educations/:id?",
    name: "MyEducations",
    component: () => import("../views/myEducations/myEducations.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/koc/:page?/:id?",
    name: "Coach",
    component: () => import("../views/coach/page.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/odemelerim",
    name: "Receipts",
    component: () => import("../views/account/Receipts.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/siparislerim",
    name: "MyOrders",
    component: () => import("../views/account/MyOrders.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/ozel-odeme/:code",
    name: "ReceiptPay",
    component: () => import("../views/account/ReceiptPay.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/ozel-odeme/:code/sonuc",
    name: "ReceiptPayResponse",
    component: () => import("../views/account/ReceiptPayResponse.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/ozel-odeme/:code/transfer",
    name: "ReceiptPayTransfer",
    component: () => import("../views/account/ReceiptPayTransfer.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/education/:id?",
    name: "Education",
    component: () => import("../views/myEducations/education.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/hesabim",
    name: "MyAccount",
    component: () => import("../views/account/myAccount.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/hesabim/:id?",
    name: "MyAccount",
    component: () => import("../views/account/myAccount.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/:culture/conversation/conversation-register",
    name: "ConversationRegister",
    component: () => import("../views/conversation/conversation-register.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/:culture/conversation/conversation-login",
    name: "ConversationLogin",
    component: () => import("../views/conversation/conversation-login.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/:culture/conversation/conversation-page",
    name: "ConversationPage",
    component: () => import("../views/conversation/conversation-page.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/:culture/ozel-firsatlar",
    name: "SpecialOffers",
    component: () => import("../views/SpecialOffers.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/:culture?/:slug?/:param?",
    name: "Page",
    component: () => import("../views/page.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/sepet",
    name: "Cart",
    component: () => import("../views/cart.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/odeme/:id",
    name: "Payment",
    component: () => import("../views/payment.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/logout.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/sanal-asistan",
    name: "SanalAsistan",
    component: () => import("../views/sanal-asistan.vue"),
    meta: { template: "noside" },
  },
  // {
  //   path: "/prices/:code?",
  //   name: "Prices",
  //   component: () => import("../views/Manage/Prices.vue"),
  //   meta: { template: "panel" },
  // },
  // Report End
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

// router.beforeEach((to, from, next) => {
//   const publicPages = ["/login", "/register"];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem("user");

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next("/login");
//   } else {
//     next();
//   }
// });

export default router;
